import { request } from '../sharedLegacy/utils'

// This is supposed to grow with time

// `/api/live/list` is still on API v1, which only returns JSON when explicitly
// asked via `format=json&raw=1`. The new fetch layer no longer injects those, so
// we pass them here until this call is migrated to `/api/2/...`.
const V1_JSON = { format: 'json', raw: '1' }

export const getLiveData = async (liveId, liveToken, options) => {
  const url = '/api/live/list'
  const data = {
    live_id: liveId,
    ...options,
    ...V1_JSON,
  }

  if (liveToken) {
    data.token = liveToken
  }

  const { firstlive } = await request({
    url,
    method: 'GET',
    data,
  })

  return firstlive
}
